import type { TSurveyAnswer, TSurveyQuestion } from "@/types"

export function filterVisibleQuestions(
  questions: TSurveyQuestion[],
  answers: Pick<TSurveyAnswer, "question_id" | "value">[],
) {
  const questionIdByUlid = new Map(questions.map((q) => [q.meta?.ulid, q.id]))
  const answerValueByQuestionId = new Map(answers.map((a) => [a.question_id, a.value]))

  return questions.filter((q) => {
    const branch = q.meta?.branch
    if (!branch) return true
    const targetId = questionIdByUlid.get(branch.question_ulid)
    return targetId != null && answerValueByQuestionId.get(targetId) === branch.value
  })
}

export function validateQuestion(
  question: TSurveyQuestion,
  value: any,
  comment: any,
  t: any,
): Record<string, string> | undefined {
  if (!question?.is_required) return

  const isString =
    question.type === "string" ||
    (question.type == "personal" &&
      ["legal_name", "quote", "intro", "position", "phone", "email"].includes(question.meta.category))

  value = isString ? comment?.trim() : value

  if (value === null || value === undefined || (typeof value === "string" && !value.length))
    return { [isString ? "comment" : "value"]: t("This field is required") }

  if (
    question.type == "personal" &&
    question.meta.category === "email" &&
    value &&
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value as string)
  )
    return { comment: t("Invalid email") }

  if (question.type == "personal" && question.meta.category === "phone" && value && /[a-zA-Z]/.test(value as string))
    return { comment: t("Invalid phone") }
}
